import { Inject, Injectable, Injector } from '@angular/core';

import { FootprintApiManager_ReportService } from './FootprintApiManager.report.index';
import { SPSCommerce_ReportService } from './SPSCommerce.report.index';


@Injectable({ providedIn: 'root' })
export class app_ReportService {

  constructor(
    private injector: Injector
  ) {
    this.FootprintApiManager = this.injector.get(FootprintApiManager_ReportService);
    this.SPSCommerce = this.injector.get(SPSCommerce_ReportService);
  }
    public FootprintApiManager: FootprintApiManager_ReportService;
    public SPSCommerce: SPSCommerce_ReportService;

  public app: app_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

